export const styles = theme => {
  return {
    container_logo: {
      flexGrow: 1,
      [theme.breakpoints.down(990)]: {
        flexGrow: 0
      }
    },
    container_user: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'flex-end',
      [theme.breakpoints.down(990)]: {
        display: 'none'
      }
    },
    user_p: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#FFFFFF'
    },
    toolBar: {
      [theme.breakpoints.down(990)]: {
        display: 'none'
      }
    },
    logo: {
      height: '42px'
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex'
      }
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none'
      }
    }
  };
};
